import { Stack } from '@ekhodealer/ekho-common/rev';

import type { AppointmentTypeConfig } from './SalesAppointmentTypeForm';

import { SalesAppointmentTypeForm } from './SalesAppointmentTypeForm';

// --- Sales Appointment Types ---

const SALES_APPOINTMENT_TYPES: AppointmentTypeConfig[] = [
	{
		key: 'salesConsultation',
		title: 'Sales Consultation',
		description: 'Let the AI schedule one-on-one consultations with your sales team. Appointments are always added to your Ekho scheduling calendar. Optionally, connect an external calendar to check availability and sync bookings.',
		defaultEnabled: true,
		tag: { children: 'Recommended', accent: 1, appearance: 'solid', size: 'small' },
	},
	{
		key: 'showroomVisit',
		title: 'Showroom Visit',
		description: 'Let buyers book a time to visit the showroom and see vehicles in person. Appointments are always added to your Ekho scheduling calendar. Optionally, connect an external calendar to check availability and sync bookings.',
	},
	{
		key: 'testDrive',
		title: 'Test Drive / Demo Ride',
		description: 'Let the AI schedule test drives and demo rides for interested buyers. Appointments are always added to your Ekho scheduling calendar. Optionally, connect an external calendar to check availability and sync bookings.',
		comingSoon: true,
	},
	{
		key: 'tradeInAppraisal',
		title: 'Trade-In Appraisal',
		description: 'Let the AI book appointments for in-person trade-in vehicle assessments. Appointments are always added to your Ekho scheduling calendar. Optionally, connect an external calendar to check availability and sync bookings.',
		comingSoon: true,
	},
];

export function SalesAppointmentsSection() {
	return (
		<Stack itemsSpacing='16'>
			{SALES_APPOINTMENT_TYPES.map((config) => (
				<SalesAppointmentTypeForm key={config.key} config={config} />
			))}
		</Stack>
	);
}

// --- Service Appointment Types ---

const SERVICE_APPOINTMENT_TYPES: AppointmentTypeConfig[] = [
	{
		key: 'routineMaintenance',
		title: 'Routine Maintenance',
		description: 'Let the AI schedule oil changes, tire rotations, brake inspections, and other routine service visits. Appointments are always added to your Ekho scheduling calendar. Optionally, connect an external calendar to check availability and sync bookings.',
		comingSoon: true,
	},
	{
		key: 'diagnosticInspection',
		title: 'Diagnostic Inspection',
		description: 'Let customers book diagnostic appointments when they notice warning lights or unusual vehicle behavior. Appointments are always added to your Ekho scheduling calendar. Optionally, connect an external calendar to check availability and sync bookings.',
		comingSoon: true,
	},
	{
		key: 'recall',
		title: 'Recall Service',
		description: 'Let the AI schedule appointments for manufacturer recall repairs and safety campaigns. Appointments are always added to your Ekho scheduling calendar. Optionally, connect an external calendar to check availability and sync bookings.',
		comingSoon: true,
	},
	{
		key: 'bodyWork',
		title: 'Body Work & Collision Repair',
		description: 'Let the AI book estimates and repair appointments for body damage, paint work, and collision repairs. Appointments are always added to your Ekho scheduling calendar. Optionally, connect an external calendar to check availability and sync bookings.',
		comingSoon: true,
	},
];

export function ServiceAppointmentsSection() {
	return (
		<Stack itemsSpacing='16'>
			{SERVICE_APPOINTMENT_TYPES.map((config) => (
				<SalesAppointmentTypeForm key={config.key} config={config} />
			))}
		</Stack>
	);
}
